import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useProgress } from "@/context/ProgressContext";

const QariContext = createContext(null);

export const QariProvider = ({ children }) => {
  const { progress, loaded, setFavoriteQari } = useProgress();
  const [qaris, setQaris] = useState([]);
  const [defaultId, setDefaultId] = useState(null);
  // local immediate choice (updated instantly on select, before backend round-trip)
  const [localId, setLocalId] = useState(localStorage.getItem("qari") || null);

  useEffect(() => {
    api.get("/content/qaris").then((r) => {
      setQaris(r.data.qaris);
      setDefaultId(r.data.default);
    });
  }, []);

  // The active voice: account favorite (synced) > local cache > server default
  const voiceId = (loaded && progress.favorite_qari) || localId || defaultId;

  const selectVoice = (id) => {
    setLocalId(id);
    localStorage.setItem("qari", id);
    setFavoriteQari(id); // sync to account -> available on all devices
  };

  const isFavorite = (id) => voiceId === id;

  return (
    <QariContext.Provider value={{ qaris, voiceId, selectVoice, isFavorite }}>
      {children}
    </QariContext.Provider>
  );
};

export const useQari = () => useContext(QariContext);
